<router-outlet />
<app-spinner-overlay />
<app-toasts />
